export const Len = (know) => {
  const UA = {
    themeC: "тема-темна",
    themeT: "тема-світла",
    languageE: "англійська",
    languageU: "українська",
    home: "головна",
    defense: "обране",
    basket: "кошик",
    profile: "профіль",
    catalog: "КАТАЛОГ ТОВАРІВ",
    price: "Ціна: ",
    uah: "грн.",
    rating: "рейтинг: ",
    buy: " КУПИТИ ",
    number: "Kількість:",
    amount: "Сума:",
    goods: "Товар:",
    address: "адреса: Полтавська область, місто Полтава, пров. Мельникова, 22",
    reserved: "© 2010 - 2023 ТОВ «Каста». Всі права захищені.",
    toOrder: "oформити замовлення",
    h4: "до 20 к в і т н я",
  };
  const EN = {
    themeC: "theme-dark",
    themeT: "theme-light",
    languageE: "english",
    languageU: "ukrainian",
    home: "home",
    defense: "defense",
    basket: "basket",
    profile: "profile",
    catalog: "CATALOG OF GOODS",
    price: "Price: ",
    uah: "uah.",
    rating: "rating: ",
    buy: " BUY ",
    number: "Number:",
    amount: "Amount:",
    goods: "Goods:",
    address: "address: Poltava region, Poltava city, ave. Melnykova, 22",
    reserved: "© 2010 -2023 <<Casta>> LLC. All rights reserved.",
    toOrder: "to order",
    h4: "until  April   20",
  };
  return know ? UA : EN;
};
